import { type AlertConfig, type AlertMessage, AlertTypes } from './components';

export class Alert {
  public static success(message: AlertMessage, alertConfig?: AlertConfig) {
    Alert.dispatchAlertEvent(AlertTypes.SUCCESS, message, alertConfig);
  }

  public static warning(message: AlertMessage, alertConfig?: AlertConfig) {
    Alert.dispatchAlertEvent(AlertTypes.WARNING, message, alertConfig);
  }

  public static error(message: AlertMessage, alertConfig?: AlertConfig) {
    Alert.dispatchAlertEvent(AlertTypes.ERROR, message, alertConfig);
  }

  public static info(message: AlertMessage, alertConfig?: AlertConfig) {
    Alert.dispatchAlertEvent(AlertTypes.INFO, message, alertConfig);
  }

  private static dispatchAlertEvent(
    type: AlertTypes,
    message: AlertMessage,
    alertConfig?: AlertConfig
  ) {
    if (message === '') {
      throw new Error('You need to specify a message');
    }

    const detail = { message, type, alertConfig };
    const event = new CustomEvent('alert/create', {
      detail,
      bubbles: true,
      cancelable: true,
    });

    document.dispatchEvent(event);
  }
}
